import CoreIcon from 'gatsby-theme-core/src/components/form-elements/radio/icon';
import styled from 'styled-components';

const Icon = styled(CoreIcon)`
  box-shadow: 0px 0px 0px 2px ${({ theme }) => theme.primaryColor};
`;

export default Icon;
